import React from 'react';
import Home from '../pageComponents/home/Home';
import SiteLayout from '../components/Layout/SiteLayout';

export default function IndexPage(props) {
  return (
    <SiteLayout {...props} pageClassNames="index">
      <Home {...props} />{' '}
    </SiteLayout>
  );
}
